window.addEventListener("load", function () {
  if (typeof Swiper === "undefined") return;

  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  if (!isMobile) return;

  new Swiper("#frame2 .swiperNews", {
    slidesPerView: 3,
    centeredSlides: true,
    spaceBetween: 10,
    loop: true,
    speed: 600,
    pagination: {
      el: "#frame2 .swiper-pagination",
      clickable: true,
    },
  });
});
